import { Box, FormControl, TextField } from '@mui/material';
import { DataGrid } from 'devextreme-react';
import ReactDOM from "react-dom/client";
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { IClientDiscount } from 'interfaces/Pricelist/IClientDiscount';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PageTitle from '../../../components/PageTitle';
import './AllClientPricelists.scss';

const AllClientPricelists = () => {
  const navigate = useNavigate();
  const pageGrid = useRef(null);
  const { getAllPricelists } = PricelistApis();
  const [pricelists, setPricelists] = useState<IClientDiscount[] | undefined>(null);
  const [textFilter, setTextFilter] = useState<string>('');

  useEffect(() => {
    pageGrid.current.instance.searchByText(textFilter);
  }, [textFilter]);

  useEffect(() => {
    getAllPricelists().then((data) => {
      if (!data.Message) {
        setPricelists(data);
      } else {
        // Do something with the error message on the page
      }
    });
  }, [getAllPricelists]);

  return (
    <>
      <PageTitle pageTitle="Client Pricelists" />

      <Box className="searchbar">
        <FormControl fullWidth>
          <TextField
            value={textFilter}
            onChange={(item) => setTextFilter(item?.target?.value)}
            size="small"
            label="Filter Client Pricelists"
            fullWidth
          />
        </FormControl>
      </Box>

      <Box className="clientPricelists">
      <DataGrid
        ref={pageGrid}
        height={800}
        dataSource={pricelists}
        allowColumnReordering={true}
        rowAlternationEnabled={true}
        showBorders={false}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        onRowDblClick={(e) =>
          navigate(`/pricelists/${encodeURIComponent(e?.data?.Client)}`, {
            replace: true,
          })
        }
        paging={{ enabled: false }}
        groupPanel={{ visible: true }}
        grouping={{ autoExpandAll: true, allowCollapsing: true }}
        scrolling={{ mode: "virtual", preloadEnabled: true }}
        headerFilter={{ visible: false }}
        selection={{ mode: "single" }}
        columns={[
          { dataField: "Client", dataType: "string" },
          { dataField: "DisplayAddress", caption: "Address", dataType: "string" },
          { dataField: "ClientMemo", caption: "Memo", dataType: "string" },
          {
            dataField: "GeneralDiscount",
            caption: "Discount",
            alignment: "left",
            width: 80,
            cellTemplate: (container, options) => {
              var discount = options?.data?.GeneralDiscount;
              container.textContent = discount < 0
                ? `BP${Math.abs(discount)}`
                : discount === 0
                ? "B0"
                : `BM${discount}`;
            },
          },
          { dataField: "IsProspect", dataType: "boolean", width: 105 },
          { dataField: "IsCodOnly", dataType: "boolean", width: 105 },
          {
            cssClass: "linkCell",
            caption: "",
            width: 100,
            alignment: "center",
            dataType: "string",
            cellTemplate: (container, options) => {
              const encodedClient = encodeURIComponent(options?.data?.Client);
              const url = `/pricelists/${encodedClient}`;
              const linkElement = (
                <a href={url} className="view-link">
                  <VisibilityIcon /> <span>View</span>
                </a>
              );

              // Ensure previous contents are cleared
              while (container.firstChild) {
                container.removeChild(container.firstChild);
              }
        
              // Create a React root and render the link inside the cell
              const root = ReactDOM.createRoot(container);
              root.render(linkElement);
            },
          },
        ]}
      />
      </Box>
    </>
  );
};

export default AllClientPricelists;
